// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1Knhy","content":"LoadingAlert_content__17no6"};